import scrollReveal from './scroll-reveal';

const initInfiniteBlog = () => {
  // Wire up infinite scroll on the blog index grid.
  const container = document.querySelector('[data-infinite-scroll="blog"]');
  if (!container || !window.agInfiniteScroll) return;

  const spinner = document.querySelector('[data-infinite-spinner]');
  const sentinel = document.querySelector('[data-infinite-sentinel]');
  const maxPages = Number.parseInt(container.dataset.maxPages, 10) || 1;
  let page = Number.parseInt(container.dataset.page, 10) || 1;
  let isLoading = false;
  let hasMore = page < maxPages;

  const queryVars = (() => {
    if (!container.dataset.queryVars) return null;
    try {
      return JSON.parse(container.dataset.queryVars);
    } catch (error) {
      try {
        return JSON.parse(window.atob(container.dataset.queryVars));
      } catch (decodeError) {
        return null;
      }
    }
  })();

  // Toggle the spinner while async loads are in flight.
  const setLoading = (loading) => {
    if (!spinner) return;
    spinner.hidden = !loading;
    spinner.setAttribute('aria-busy', loading ? 'true' : 'false');
  };

  // Fetch the next page and append it to the grid.
  const loadMore = async () => {
    if (isLoading || !hasMore) return;
    isLoading = true;
    setLoading(true);

    const body = new URLSearchParams();
    body.set('action', 'ag_load_more_posts');
    body.set('nonce', window.agInfiniteScroll.nonce);
    body.set('page', String(page + 1));
    if (queryVars) {
      body.set('query_vars', JSON.stringify(queryVars));
    }
    if (container.dataset.excludeIds) {
      body.set('exclude_ids', container.dataset.excludeIds);
    }

    try {
      const response = await fetch(window.agInfiniteScroll.ajaxUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' },
        body,
      });
      const payload = await response.json();
      if (!payload || !payload.success) {
        throw new Error('Failed to load more posts');
      }

      if (payload.data && payload.data.html) {
        container.insertAdjacentHTML('beforeend', payload.data.html);
        scrollReveal.init();
      }

      page = payload.data && payload.data.nextPage ? payload.data.nextPage - 1 : page + 1;
      hasMore = payload.data ? Boolean(payload.data.hasMore) : page < maxPages;
      container.dataset.page = String(page);

      setLoading(false);
    } catch (error) {
      setLoading(false);
    } finally {
      isLoading = false;
    }
  };

  // Only run when the browser can observe the sentinel.
  if (!('IntersectionObserver' in window)) {
    return;
  }

  if (!sentinel) {
    return;
  }

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          loadMore();
        }
      });
    },
    {
      root: null,
      rootMargin: '0px 0px 25% 0px',
      threshold: 0.1,
    }
  );

  observer.observe(sentinel);
};

export default initInfiniteBlog;
